<template>
  <div class="genre has-background-white-bis fixspace">

    <section class="hero is-medium has-background-white-ter is-bold is-hidden-mobile">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title is-uppercase" style="font-weight: 900;">
            {{ $t('general.genre') }}
          </h1>
          <h2 class="subtitle py-5 has-text-grey-light">
            GENRE
          </h2>
        </div>
      </div>
    </section>

    <section class="section py-5 has-background-white-ter is-bold is-hidden-tablet">
      <div class="container">
        <h1 class="title is-4 is-uppercase" style="font-weight: 900;">
          {{ $t('general.genre') }}
        </h1>
      </div>
    </section>

    <section class="section">

      <div class="container is-max-desktop" v-if="loading">
        <div class="columns is-multiline is-variable is-8-desktop is-mobile">
          <div class="column is-4-desktop is-4-tablet is-half-mobile my-4"
            v-for="i in media" :key="i">
            <div class="media-content">
              <figure class="image is-1by1 skeleton">
                <div class="skeleton-block"></div>
              </figure>
            </div>
          </div>
        </div>
      </div>

      <div class="container is-max-desktop" v-if="!loading">
        <div class="columns is-multiline is-variable is-8-desktop is-mobile">
          <div class="column is-4-desktop is-4-tablet is-half-mobile my-4"
            v-for="tag in genre" :key="tag.slug">
            <router-link :to="{ path: '/genre/' + tag.slug }">
              <div class="card" style="border: 1px solid #dedede;">
                <div class="card-image">
                  <b-image
                    :src="'/assets/genre/webp/'+ tag.slug +'.webp'"
                    :webp-fallback="'/assets/genre/'+ tag.slug +'.jpg'"
                    :src-fallback="require('@/assets/no-genre.jpg')"
                    :alt="tag.trans || tag.name"
                    ratio="is-1by1"
                  >
                    <!-- <b-skeleton
                      :rounded="false"
                      class="skeleton-placeholder"
                      slot="placeholder"
                      height="100%"
                    ></b-skeleton> -->
                  </b-image>
                </div>
                <div class="card-content is-overlay
                is-flex is-justify-content-center is-align-items-center"
                style="background-color: rgba(0,0,0,0.55);">
                  <span class="has-text-white has-text-weight-semibold
                    is-size-5-desktop is-size-6-mobile">
                    {{ tag.trans || tag.name }}
                  </span>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getTags } from '@/api/api';

export default {
  name: 'Genre',

  metaInfo() {
    return {
      title: this.$t('title.genre'),
      meta: [
        { name: 'description', vmid: 'description', content: this.$t('about.abouthero1') },
        { property: 'og:title', vmid: 'og:title', content: this.$t('title.genre') },
        { property: 'og:image', vmid: 'og:image', content: 'https://musian.app/assets/open_graph_logo.jpg' },
        { property: 'og:description', vmid: 'og:description', content: this.$t('about.abouthero1') },
      ],
    };
  },

  data() {
    return {
      loading: true,
      media: 12,
      genre: [],
    };
  },

  computed: {

  },

  created() {
    this.fetchData();
  },

  mounted() {
    this.forGtag();
  },

  beforeDestroy() {
    clearTimeout(this.timer);
  },

  methods: {
    fetchData() {
      getTags(null, { headers: { locale: this.$i18n.locale } })
        .then((result) => {
          const { data } = result.data;

          this.genre = data.filter((item) => item.type === 'genre');

          this.loading = false;
        })
        .catch((err) => { console.error(err); });
    },

    forGtag() {
      this.timers = setTimeout(() => {
        this.$emit('forGtagStatus', this.$t('title.genre'));
      }, 500);
    },
  },
};
</script>
